import { Text } from '@backstage/ui';
import styles from './ExampleQuote.module.css';

export function ExampleQuote({
  title,
  color = 'primary',
}: {
  title: string;
  color?: 'primary' | 'secondary';
}) {
  return (
    <div className={styles.quote}>
      <span className={styles.bar} aria-hidden="true" />
      <Text variant="body-small" color={color} className={styles.title}>
        {title}
      </Text>
    </div>
  );
}
